import {handleActions} from 'redux-actions';
import {ModalData} from '../constants/models';

const modalReducers = handleActions({
    OPEN_MODAL: (state, {payload = 'system_msg'}) => (
        state.mergeDeep({
            modalIsOpen: {[payload]: true}
        })
    ),
    CLOSE_MODAL: (state, {payload = 'system_msg'}) => (
        state.mergeDeep({
            modalIsOpen: {[payload]: false}
        })
    ),
    CHANGE_MODAL: (state, {payload}) => (
        state.merge({
            modalName: payload
        })
    ),
    SET_MODAL_MSG: (state, {payload}) => (
        state.merge({
            modalMsg:  payload
        })
    )
}, ModalData);

export default modalReducers;


// WEBPACK FOOTER //
// ./src/dashboards_redux/reducers/ModalReducers.jsx